import controller from './v5-frame.controller';
import template from './v5-frame.html';
import './v5-frame.scss';

export default {
	template,
	bindings: {
		src: '<',
		params: '<?',
		frameClasses: '@?',
		onMessage: '&?'
	},
	controller,
	controllerAs: '$ctrl',
};
